import * as React from 'react';

const SvgBannerBottom = (props) => (
  <svg
    viewBox='0 0 1600 101'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1644.36-318.448c-27.78-6.28-1392.696 10.622-1453.419 14.25-.228-17.685-15.715 6.212-26.314 2.192 0 0-19.509-1.107-19.369-2.192 0-1.444-14.302-1.605-17.896 0-34.078 15.998-104.453-29.51-127.56 0-13.49 4.814-1.744 322.713-1.744 322.713-9.162 5.937-7.327 59.195 1.743 82.395C31.77 46.068 77.03 22.333 77.03 22.333 62.3 57.576 52.777 82.075 59.459 88.703c14.307 14.157 27.893-22.237 67.903-30.945 23.448-5.114 1462.328-1.717 1491.658-3.14 24.82-1.186 37.2-8.115 38.1-20.032.94-12.12 28.71-323.427 22.33-324.899'
      fill='#E00034'
    />
  </svg>
);

export default SvgBannerBottom;
